module.exports = __webpack_public_path__ + "media/images/lane/sign0.5-4f17a5205e5f81ddc210cf1df153d407.png";